import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	minWidth: {
		width: '100%',
	}
});

const ButtonCard = ({dataUrl}) => {

	const classes = useStyles();

    return (
		<Button className={classes.minWidth} color="primary" variant="contained" href={dataUrl}>
			{'SVG on Codepen'}
		</Button>
    )
}

export default ButtonCard;